import { PayloadAction } from '../types/payload-action';
import { BetaTesterDto } from '../types/BetaTesterDto';
import { STORE_BETA_TESTER } from '../actions/config.actions';
import * as _ from 'lodash';
import { Action } from '@ngrx/store';

export interface ConfigState {
  isBetaTester;
}

const initialState: ConfigState = {
  isBetaTester: {},
};

export function configReducer(
  state: ConfigState = initialState,
  action: Action
) {
  return {
    isBetaTester: isBetaTesterReducer(state.isBetaTester, action),
  };
}

export function isBetaTesterReducer(
  state,
  action: PayloadAction<BetaTesterDto>
) {
  switch (action.type) {
    case STORE_BETA_TESTER:
      if (!(action.payload && action.payload.feature)) {
        return state;
      }

      let newState = _.cloneDeep(state);
      newState[action.payload.feature] = action.payload.enabled;
      return newState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/reducers/config-reducer.ts